import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement
} from "@wingspanhq/fe-component-library";
import { Engagement } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { ActionEngagementDetails } from "../components/ActionEngagementDetails";

export interface DeleteNotAllowedModalProps {
  engagement: Engagement;
  onClose: () => void;
}

export const DeleteNotAllowedModal: React.FC<DeleteNotAllowedModalProps> = ({
  engagement,
  onClose
}) => {
  return (
    <>
      <ActionEngagementDetails engagement={engagement} />

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Engagement cannot be deleted when:"
      >
        <WSElement as="ul" ml="L">
          <li>Active assignments exist.</li>
          <li>Historical payment data is linked to this engagement.</li>
        </WSElement>
        If this engagement is no longer used, it can be archived instead.
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useDeleteNotAllowedModal = () => {
  return useWSModal(DeleteNotAllowedModal, {
    title: "Delete engagement",
    size: "M"
  });
};
